import { render, staticRenderFns } from "./upload-image.vue?vue&type=template&id=330ed2e0&scoped=true"
import script from "./upload-image.vue?vue&type=script&lang=js"
export * from "./upload-image.vue?vue&type=script&lang=js"
import style0 from "./upload-image.vue?vue&type=style&index=0&id=330ed2e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_4rliqqz3ui7xo7iaw2ukiguuga/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330ed2e0",
  null
  
)

export default component.exports